export function scrollIntoViewWithOffset (element, offset = 200) {
  const elementTop = element.getBoundingClientRect().top
  const offsetPosition = elementTop + window.pageYOffset - offset
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  })
}
